
import { getColorByType } from 'counselor-mobile-ui/utils/ui/color'

export const REPORT_STATUS_APPROVING = '1'
export const REPORT_STATUS_COMPLETE = '3'
export const REPORT_STATUS_REJECT = '2'
export const REPORT_STATUS_REPLACE = '0'
export const REPORT_STATUS_PASS = '9'

export const REPORT_STATUS_CONFIG = {
  [REPORT_STATUS_APPROVING]: '待审批',
  [REPORT_STATUS_COMPLETE]: '已完成',
  [REPORT_STATUS_REJECT]: '已驳回',
  [REPORT_STATUS_REPLACE]: '代销假',
  [REPORT_STATUS_PASS]: '通过',

}

export const REPORT_STATUS_FLOW_CONFIG = {

  [REPORT_STATUS_APPROVING]: {
    label: '待审批',
    fontClassname: 'font-primary',
    borderColor: getColorByType('warning'),
  },
  [REPORT_STATUS_COMPLETE]: {
    label: '已完成',
    fontClassname: 'font-success',
    borderColor: getColorByType('success'),
  },
  [REPORT_STATUS_REJECT]: {
    label: '已驳回',
    fontClassname: 'font-error',
    borderColor: getColorByType('error'),
  },
  [REPORT_STATUS_REPLACE]: {
    label: '代销假',
    fontClassname: 'font-error',
    borderColor: getColorByType('error'),
  },
  [REPORT_STATUS_PASS]: {
    label: '通过',
    fontClassname: 'font-success',
    borderColor: getColorByType('success'),
  },
}
